import React, {useState, useEffect} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import { IconButton, Switch } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import NavLink from '../nav_link/NavLink';
import AddRounded from '@mui/icons-material/AddRounded';

const Services = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [errorMessage, setErrorMessage] = useState(null);
     const [status, setStatus] = useState("submited");
     const [searchQuery, setSearchQuery] = useState(null);
     const tableHead = ["Service", "Time", "Charge", "Commission", "Enabled", ""];
     const selectionItems = ["New", "Rejected", "Enabled", "Desabled"];
     const selectionItemKeys = ["submited", "rejected", "enabled", "desabled"];

     const onPageChange = async (e, pageIndex, mStatus) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);
               params.append("filterByNew", true);

               if(searchQuery){
                    params.append("searchQuery", searchQuery);
               }
               if(mStatus){
                    params.append("status", mStatus);
               }
               else params.append("status", status);
               const res = await axiosInstance.get('admin/services', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Services</h5>
                    </div>

                    <div className="d-flex align-items-center">
                         <div className='banner_create' onClick={()=> naviagte('/admin-create-services')}>
                              <AddRounded style={{color: '#fff'}}/>
                              <button>Create</button>
                         </div>
                    </div>
                    {/* <DropdownMenu items={selectionItems} onChange={(value, i)=> {
                              const status = selectionItemKeys[i];
                              setStatus(status);
                              onPageChange(null, 1, status);
                         }}/> */}
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
          </>
     );
}

const Item = (props) => {
     const { name, _id, imageUrl, servicesTime, serviceCharge, commission, enabled, date } = props.data;

     const [checked, setChecked] = useState(enabled);
     const [deleted, setDeleted] = useState(false);

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onCheckedChange = async (checked) => {
          setChecked(checked)
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               rBody.append("enabled", checked)
               const res = await axiosInstance.patch("admin/service", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setChecked(!checked);
          }
     }

     const onDelete = async () => {
          setDeleted(true)
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               const res = await axiosInstance.delete("admin/service", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setDeleted(false);
          }
     }

     useEffect(()=> {
          setChecked(enabled)
     }, [enabled]);

     return(
          <tr>
               <td>{name}</td>
               <td><div className="d-flex flex-wrap">{servicesTime.trim().split(",").map(v => v.trim()).filter(v => v !== "").map(val => <span className="p-2 m-1 rounded border text-center" style={{background: '#f2f2f2', }}>{val}</span>)}</div></td>
               <td>₹{serviceCharge}</td>
               <td>₹{commission}</td>
               <td><Switch onChange={(e)=>{onCheckedChange(e.target.checked)}} checked={checked} /></td>
               <td><button onClick={()=>naviagte("/admin-edit-services?id=" + _id)} style={{background: "green", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Edit</button></td>
               {/* <td><button onClick={onDelete} style={{background: "red", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Delete</button></td> */}
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default Services;